import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CancelProjectWidget from '../../../widgets/closeProject/CancelProjectWidget'
import CancelProjectHistoryWidget from '../../../widgets/closeProject/CancelProjectHistoryWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getCancelForm } from '../../../redux/actions/cancelOfProject'

export default function CancelProjectLawyer(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getCancelForm(proposalId)
      if (response.success) setSchemas(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}

        {schemas?.forms?.requestNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              isLawyer={true}
              fileList={schemas.forms.fileList}
              attachmentSchema={schemas.forms.attachment}
              requestStep={schemas.forms.requestNote.requestStep}
            />
            <br />
          </>
        )}

        {schemas?.forms?.requestNoteAccept && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.requestNoteAccept.disabled}
              schema={schemas.forms.requestNoteAccept}
              isLawyer={true}
              fileList={schemas.forms.fileList}
              attachmentSchema={schemas.forms.attachment}
              //requestStep={schemas.forms.requestNote.requestStep}
              hideUpload={true}
            />
            <br />
          </>
        )}

        {/* {schemas?.forms?.saveCancelProjectNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.saveCancelProjectNote.disabled}
              schema={schemas.forms.saveCancelProjectNote}
              attachmentSchema={schemas.forms.attachment}
            />
            <br />
          </>
        )} */}

        {schemas?.forms?.cancelProjectHistory && (
          <>
            <CancelProjectHistoryWidget
              data={schemas.forms.cancelProjectHistory.value}
              header={schemas.forms.cancelProjectHistory.header}
              onSuccess={() => handleGetSchema(projectId)}
              schemaButton={schemas.forms}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchemaNote = {
  header: 'บันทึกสถานะทางกฎหมาย',
  buttonText: 'บันทึกผลการพิจารณา',
  buttonText2: null,
  requestStep: 'RequestSummary',
  note: {
    name: 'Note',
    label: 'หมายเหตุ',
    value: null,
    hint: 'ระบุหมายเหตุ',
    validators: [],
  },
  approveType: {
    options: [
      {
        disabled: false,
        label: 'ส่งกลับสำนักดำเนินการ',
        value: 1,
      },
      {
        disabled: false,
        label: 'ฝ่ายกฎหมายรับดำเนินการ',
        value: 2,
      },
    ],
    name: 'approveType',
    label: null,
    value: null,
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาระบุ ผลการพิจารณา',
      },
    ],
  },
}
